import { loadable } from "components/SpruceLoader";

export const TrendChartsPlugin = loadable(() => import("./TrendChartsPlugin"));
